import '../Select/Select.css';

import * as React from 'react';


export interface IOption {
  value: number;
  title: string;
}


export interface ISelectProps {
  options: IOption[];
  selectedValue: number;
  className?: string;
  onSelect(option: IOption): void;
  onToggle?(): void;
}

export interface ISelectState {
  isOpen: boolean;
}

export default class Select extends React.Component<ISelectProps, ISelectState> {
  select: HTMLElement;
  constructor(props: ISelectProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  renderOption = (option: IOption) => {
    const {
      value,
      title,
    } = option;
    return (
      <div className="dropdownmenu-option"
        key={value}
        onClick={() => {
          this.setState({ isOpen: false }, () => this.props.onSelect(option));
        }}
      >
        {title}
      </div>
    );
  }

  componentDidMount() {
    window.addEventListener('click', this.onClose, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClose, true);
  }

  onClose = (e: any) => {
    const dropMenu = e.target.closest('.dropdownmenu');
    if (dropMenu !== this.select) {
      this.setState({ isOpen: false });
    }
  }
  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.onToggle != undefined) {
      this.props.onToggle();
    }
  }

  render() {
    const {
      isOpen,
    } = this.state;
    const {
      options,
    } = this.props;

    const selectedValue = this.props.options.find(op => op.value === this.props.selectedValue);
    // TODO need add styling if will used more stahn once
    return (

      <div onClick={this.onToggle} className="select-dropdown dropdownmenu" ref={select => this.select = select!}>
        <div className="dropdownmenu-btn" onClick={e => e.nativeEvent.stopImmediatePropagation()}>
          {selectedValue && selectedValue.title}
          <i className={`fas fa-angle-${isOpen ? 'up' : 'down'}`} />
        </div>
        {isOpen &&
          <div className="dropdownmenu-options-list">
            {options.map(this.renderOption)}
          </div>
        }
      </ div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/Select.tsx